import { useAppSelector } from "../redux/store";

export function useAuth() {
    const user = useAppSelector(s => s.appData.currentUser)
    return { user }
}